import CampaignMappingFieldResourcePagingResultModel from '../../generated/types/model/resource/CampaignMappingFieldResourcePagingResultModel';

export default class CampaignMappingFieldResourcePagingResultViewModel extends CampaignMappingFieldResourcePagingResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
